import React from 'react';
export function Footer() {
  return <footer className="relative w-full py-12 bg-midnight-deep border-t border-white/5" role="contentinfo" data-id="element-9">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-11">
          {/* Logo and location */}
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-12">
            <span className="font-sora font-bold text-base tracking-[0.15em] text-white" data-id="element-13">
              KEYSTONEGAMES
            </span>
            <span className="font-inter text-sm text-text-muted" data-id="element-14">
              Limassol, Cyprus
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8" data-id="element-15">
            <a href="#" className="font-inter text-sm text-text-muted hover:text-text-secondary transition-colors duration-300" data-id="element-16">
              Privacy Policy
            </a>
            <a href="#" className="font-inter text-sm text-text-muted hover:text-text-secondary transition-colors duration-300" data-id="element-17">
              Terms of Service
            </a>
          </div>

          {/* Copyright */}
          <p className="font-inter text-sm text-text-muted" data-id="element-18">
            © 2026 Keystonegames. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}